import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import FolderOverviewFirstPageQueryNode, {
	type FolderOverviewFirstPageQuery$data,
	type FolderOverviewFirstPageQuery$variables,
} from './__generated__/FolderOverviewFirstPageQuery.graphql.ts';
import FolderRedirectFirstChildQueryNode, {
	type FolderRedirectFirstChildQuery$data,
	type FolderRedirectFirstChildQuery$variables,
} from './FolderLanding/__generated__/FolderRedirectFirstChildQuery.graphql.ts';

export async function preloadFolderData(contentId: string) {
	return waitForAllReturnWhenError([
		query<FolderOverviewFirstPageQuery$data, FolderOverviewFirstPageQuery$variables>({
			query: FolderOverviewFirstPageQueryNode,
			variables: { id: contentId, contentId },
		}),
		query<FolderRedirectFirstChildQuery$data, FolderRedirectFirstChildQuery$variables>({
			query: FolderRedirectFirstChildQueryNode,
			variables: { id: contentId },
		}),
	]);
}
